import { useEffect, useState } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { frameCopy } from '@/components/layout/frame-copy';

export function StaleBanner() {
  const client = useQueryClient();
  const { i18n } = useTranslation();
  const copy = frameCopy(i18n.language);
  const [snap, setSnap] = useState<{ at: number } | null>(null);

  useEffect(() => {
    const read = () => {
      let failing = false;
      let latest = 0;
      for (const query of client.getQueryCache().getAll()) {
        if (query.state.dataUpdatedAt > latest) latest = query.state.dataUpdatedAt;
        if (query.state.status === 'error') failing = true;
      }
      setSnap(failing ? { at: latest || Date.now() } : null);
    };
    read();
    return client.getQueryCache().subscribe(read);
  }, [client]);

  if (!snap) return null;
  const clock = new Date(snap.at).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });

  return (
    <div className="stale" role="status">
      <span>
        <b>{copy.stale}</b>
        {copy.staleBody} {clock} {copy.staleTail}
      </span>
      <button type="button" className="np-btn np-btn-quiet" onClick={() => void client.invalidateQueries()}>
        {copy.retry}
      </button>
    </div>
  );
}
